module.exports = __webpack_public_path__ + "static/media/Figure6.a51879bd.jpg";